export default __webpack_public_path__ + "static/media/marathi_edu_m.cdb446f6.wav";